<ion-content class="ion-padding">

  <div class="read-item" *ngFor="let readState of readStates">
    <h3>{{readState.employee?.firstName}} {{readState.employee?.lastName}}</h3>
    <div class="time">{{dayjs(readState.readDate).fromNow()}}</div>
  </div>

</ion-content>